// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:

//<a href="images/content/sample-02.jpg">
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>

// Converts to:

//<a href="images/content/sample-02.jpg" data-fancybox>
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>


const links = document.querySelectorAll('.entry-content a:not(.entry-content .gallery-icon a)');

links.forEach((link) => {
  const image = link.querySelector('a[href$=".jpg"] > img, a[href$=".png"] > img, a[href$=".jpeg"] > img');

  if (image !== null) {
    link.setAttribute("data-fancybox", "");

    if (image.classList.contains("aligncenter")) {
      image.parentNode.classList.add("aligncenter");
    }
  }
});

